import { render, staticRenderFns } from "./InputSugestaoProdutos.vue?vue&type=template&id=30ade68e&"
import script from "./InputSugestaoProdutos.vue?vue&type=script&lang=js&"
export * from "./InputSugestaoProdutos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports